import { createRoot } from "react-dom/client";
import {createBrowserRouter,RouterProvider,} from "react-router-dom";
import App from "./App";
import { AllData } from "./Data/AllData";
import ScrollToTop from "react-scroll-to-top";
import AllProperties from "./Properties/AllProperties";
import AllDetials from "./Detials/AllDetials";
import AllContact from "./Contactus/AllContact";
import AllProducts from "./Products/AllProducts";
import AllShop from "./Shop/AllShop";
import AllCart from "./Cart/AllCart";
const router = createBrowserRouter([
  {
    path: "/",
    element: <App/>,
  },
  {
    path: "properties",
    element: <AllProperties/>,
  },
  {
    path: "detials",
    element: <AllDetials/>,
  },
  {
    path: "contactus",
    element: <AllContact/>,
  },
  {
    path: "products",
    element: <AllProducts/>,
  },
  {
    path: "shop",
    element: <AllShop/>,
  },
  {
    path: "cart",
    element: <AllCart/>,
  },
]);

createRoot(document.getElementById("root")).render(
    <AllData>
        <RouterProvider router={router} />
        <ScrollToTop 
        smooth
         />
    </AllData>
);
